import {ErrorBase} from "./ErrorBase";

export class ValidationError extends ErrorBase {


    constructor(id: string, message: string, messageKeyString: string, errorTypeId: string = undefined, field:string = undefined) {
        super(id, message, messageKeyString, errorTypeId, field);   
    }
    
}